import { Component } from '@angular/core';

import { JanelaComponent } from './../janela/janela.component';

@Component({
  selector: 'visualiza-cadastro',
  templateUrl: './visualiza-cadastro.component.html',
  styleUrls: ['./visualiza-cadastro.component.scss']
})

export class VisualizaCadastroComponent extends JanelaComponent {

  isFiltroCollapsed:boolean = true;
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/visualiza-cadastro/visualiza-cadastro.component.ts